<template>
    <b-modal v-model="localShow" centered hide-footer hide-header>
        <b-row align-h="around">
            <b-col align-self="end" cols="10"></b-col>
            <b-col align-self="end" cols="2">
                <img
                    @click="localShow = false"
                    class="close"
                    src="@/assets/images/mood-pulse/close.svg"
                />
            </b-col>
        </b-row>
        <b-container fluid>
            <b-row class="pb-2" align-h="start">
                <p class="title">
                    {{ $t('moodPulse.report.sectionFilterTitle') }}
                </p>
            </b-row>
            <b-row class="pl-2 pr-1" align-h="start">
                <p class="text">
                    {{ $t('moodPulse.modal.placeholderWho') }}
                </p>
                <departments
                    class="mb-0"
                    :value.sync="localSections"
                    enableSelectAll
                    style="width: 100%"
                />
            </b-row>
            <b-row class="pb-2 pt-3" align-h="center">
                <b-button
                    @click="localShow = false"
                    variant="outline-primary"
                    class="mr-3 small-btn"
                >
                    {{ $t('moodPulse.pauseModal.cancelBtn') }}
                </b-button>
                <b-button
                    @click="
                        getAnswers()
                        localShow = false
                    "
                    variant="primary"
                    class="small-btn"
                >
                    {{ $t('moodPulse.report.filterBtn') }}
                </b-button>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
import { Departments } from '@/views/components/fields'

export default {
    components: { Departments },
    data() {
        return {
            localSections: [],
        }
    },
    props: {
        show: {
            required: true,
            type: Boolean,
        },
        sections: {
            required: true,
            type: Array,
        },
        getAnswers: {
            required: true,
            type: Function,
        },
    },
    watch: {
        localSections() {
            this.$emit('change', this.localSections)
        },
    },
    computed: {
        localShow: {
            get() {
                return this.show
            },
            set(localShow) {
                this.$emit('click', localShow)
            },
        },
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 21px;
    color: #3b3f4e;
}

.text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #3b3f4e;
}

.small-btn {
    border-radius: 5px;
    width: 84px;
    height: 25px;
    padding: 0;
}
</style>
